class AccountSummary {
  total: number;
  availableBalance: number;
  blockedBalance: number;
  unclearedBalance: number;
  currency: string;

  constructor(
    total: number,
    availableBalance: number,
    unclearedBalance: number,
    blockedBalance: number,
    currency: string,
  ) {
    this.total = total;
    this.availableBalance = availableBalance;
    this.unclearedBalance = unclearedBalance;
    this.blockedBalance = blockedBalance;
    this.currency = currency;
  }
}

export { AccountSummary };
